<template>
  <div class="materials-panel">
    <h3>Teaching materials</h3>
    <p>The private pages educators use to run this program: slides, teaching scripts, handouts, case banks. They come from a program folder in the course materials repository on the server, and only educators running this program can open them.</p>
    <p v-if="!course._id">Save the course first, then choose its teaching materials.</p>
    <template v-else>
      <p v-if="current" class="current">
        Assigned: <strong>{{ current.title }}</strong> · folder <code>{{ current.slug }}</code>
        <el-button size="mini" :disabled="busy" @click="assign('')">Remove</el-button>
      </p>
      <p v-else>No teaching materials are assigned to this course.</p>

      <div class="assign-row">
        <el-select v-model="slug" :disabled="busy" placeholder="Choose a program folder" aria-label="Teaching materials folder" filterable allow-create default-first-option>
          <el-option v-for="item in folders" :key="item.slug" :label="`${item.title} · ${item.slug}`" :value="item.slug" />
        </el-select>
        <el-button type="primary" :loading="busy" :disabled="!slug || (current && current.slug === slug)" @click="assign(slug)">Assign</el-button>
        <el-button :disabled="busy" @click="loadFolders">Refresh list</el-button>
      </div>
      <p v-if="!available" class="upload-error" role="alert">The course materials repository was not found on the server. Clone it there, then refresh this list.</p>
      <p v-else-if="!folders.length">No program folders were found on the server yet.</p>
      <p class="hint">To add or update materials, pull the course materials repository on the server. Changes show immediately; nothing needs to be uploaded here.</p>
      <p v-if="error" class="upload-error" role="alert">{{ error }}</p>
      <p v-else-if="notice" class="upload-success" role="status">{{ notice }}</p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'EducatorMaterialsPanel',
  props: {
    course: { type: Object, required: true },
    api: { type: Function, required: true }
  },
  data() {
    return { folders: [], available: true, slug: '', busy: false, error: '', notice: '' }
  },
  computed: {
    current() { const value = this.course.materials; return value && value.slug ? value : null }
  },
  watch: {
    'course._id': { immediate: true, handler(id) { this.error = ''; this.notice = ''; this.slug = this.current ? this.current.slug : ''; if (id) this.loadFolders() } }
  },
  methods: {
    async loadFolders() {
      try {
        const result = await this.api('material_folders')
        this.folders = result.items || []
        this.available = result.available !== false
      } catch (e) { this.error = e.message || 'Unable to list the program folders.' }
    },
    async assign(slug) {
      if (this.busy) return
      this.busy = true; this.error = ''; this.notice = ''
      try {
        const course = await this.api('material_assign', { course_id: this.course._id, slug })
        this.$emit('assigned', course.materials || null)
        this.notice = slug ? 'Educators running this program can now open these materials.' : 'Teaching materials removed from this course.'
        if (!slug) this.slug = ''
      } catch (e) { this.error = e.message || 'Request failed' } finally { this.busy = false }
    }
  }
}
</script>

<style scoped>
.materials-panel { margin: 24px 0; padding-top: 8px; border-top: 1px solid #e4e7ed; }
.current { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; }
.assign-row { display: flex; flex-wrap: wrap; gap: 8px; align-items: center; margin-bottom: 8px; }
.assign-row .el-select { min-width: 320px; }
.hint { color: #909399; }
.upload-error { color: #f56c6c; }
.upload-success { color: #529b2e; }
</style>
